import { render } from "./TableSkeleton.vue?vue&type=template&id=827d61b2"
const script = {}

import exportComponent from "/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMarkupTable,QSkeleton});
